// Returns states that should trigger a notification for the customer (e.g. booking accepted, pending payment)
export const statesNeedingCustomerAttention = [
  'pending-payment', // Customer needs to pay after provider accepts
  // Add more states if needed
];
